import Autosize from 'autosize';

export default {
  setup: function() {
    window.addEventListener('load', function () {
      setupTextAreas();
    });
  }
}


function setupTextAreas() {
  let elements = document.querySelectorAll('[data-autosize]');
  for (let el of elements) {
    Autosize(el);
  }

}
